module.exports = "https://cdn01.riselinkedu.com/assets/lottie/img_7.429cf99b.png";